import * as Linking from "expo-linking";
import { Platform } from "react-native";

export function openExternalUrl(url: string) {
  if (Platform.OS === "web" && typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }

  return Linking.openURL(url);
}
